import React, { useEffect, useState, useContext } from "react";
import { Button, Input, Label, ButtonGroup } from "reactstrap";
import Alert from "react-s-alert";
import { useHistory } from "react-router-dom";
import PsychometricService from "../../services/PsychometricService";
import { ThemeContext } from "../../contexts/ThemeContext";
import { PsychometricContext } from "../../contexts/PsychometricContext";
import GeneralNavbar from "../general/GeneralNavbar";
import ErrorBoundary from "../general/ErrorBoundary";

const PsychometricTestTakerPortal = (props) => {
  const history = useHistory();
  const { theme } = useContext(ThemeContext);
  const {
    signedOrganization,
    setSignedEmail,
    setSignedPassword,
    setSignedOrganization,
    setIsOrganization,
    setSignedID,
    setSignedFirstName,
    setSignedLastName,
    setIsStudent,
    isStudent
  } = useContext(PsychometricContext);
  const [user, setUser] = useState({
    uniqueID: "",
    firstName: "",
    lastName: "",
    organization: "",
  });
  const [individualUser, setIndividualUser] = useState({ email: "", password: ""});
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [isTwoFactorOn, setIsTwoFactorOn] = useState(false);

  useEffect(() => {
    console.log("individualUser: ", individualUser)
    const params = new URLSearchParams(props.location.search);
    setUser({
      uniqueID: params.get("id") || "",
      firstName: params.get("firstName") || "",
      lastName: params.get("lastName") || "",
      organization: params.get("organization") || "",
    });
  }, [props.location.search]);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleIndividualChange = (e) => {
    setIndividualUser({ ...individualUser, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { uniqueID, firstName,lastName, organization } = user;
      const response = await PsychometricService.getPsychometricUser(
        uniqueID,
        firstName,
        lastName,
        organization
      );

      if (response?.user) {
        console.log("response:" , response)
        setSignedID(uniqueID);
        setSignedFirstName(firstName);
        setSignedLastName(lastName);
        setSignedOrganization(organization);
        setIsOrganization(true);
        const orgResponse = await PsychometricService.getPsychometricOrganization(response.user.organizationEmail);
       console.log("ORGRESPONSE:", orgResponse);
        setIsStudent(orgResponse.user.isStudent);
        console.log("ISSTUDENT:", isStudent);


        await PsychometricService.updateUserOrganizationInfo(
          uniqueID,
          firstName,
          lastName,
          organization
        );



        Alert.success("User authenticated successfully");
        // Updated URL structure
        props.history.push(`/psychometrictest/${encodeURIComponent(uniqueID)}/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}/${encodeURIComponent(organization)}`);
      } else {
        Alert.error("User not found or response format incorrect");
      }
    } catch (error) {
      Alert.error("Error authenticating user");
      console.error("Error authenticating user:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleIndividualSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const {email, password } = individualUser;
      const response = await PsychometricService.getPsychometricIndividual(
        email
      );

      if (response?.user) {
        console.log("response:" , response)
        setSignedEmail(email);
        setIsOrganization(false);

        Alert.success("User authenticated successfully");
        // Updated URL structure
        props.history.push(`/psychometrictest/${encodeURIComponent(email)}`);
      } else {
        Alert.error("User not found or response format incorrect");
      }
    } catch (error) {
      Alert.error("Error authenticating user");
      console.error("Error authenticating user:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <ErrorBoundary errorAt="At User SignIn GeneralNavbar">
        <GeneralNavbar isSignInPage={true} />
      </ErrorBoundary>
      
      <div className="text-center mt-4">
        <h1 style={theme.headingXXL}>Psychometric TestTaker Portal</h1>
      </div>
      
      <div className="p-3 col-md-4 mt-5 mb-5 offset-md-4" style={theme.form}>
        {!activeTab ? (
          <div style={{ paddingLeft: "10%", paddingRight: "10%" }}>
            <h2 style={theme.heading}>Select User Type</h2>
            <div className="mt-4">
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="radio"
                  name="userType"
                  id="organizationType"
                  onChange={() => setActiveTab("testTaker")}
                  style={theme.formInput}
                />
                <label className="form-check-label" htmlFor="organizationType" style={theme.formBodyText}>
                  Organization Test Taker
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="userType"
                  id="individualType"
                  onChange={() => setActiveTab("organization")}
                  style={theme.formInput}
                />
                <label className="form-check-label" htmlFor="individualType" style={theme.formBodyText}>
                  Individual User Test Taker
                </label>
              </div>
            </div>
          </div>
        ) : activeTab === "testTaker" ? (
          <form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
            <h2 id="login-heading" style={theme.heading}>
              Organization User Test Taker Sign In
            </h2>
            <br />
            <Label htmlFor="uniqueID" style={theme.formBodyText}>
              User ID
            </Label>
            <Input
              type="text"
              id="uniqueID"
              name="uniqueID"
              value={user.uniqueID}
              onChange={handleChange}
              className="form-control"
              required
              style={theme.formInput}
            />  
            <br />
            <Label htmlFor="firstName" style={theme.formBodyText}>
              First Name
            </Label>
            <Input
              type="text"
              id="firstName"
              name="firstName"
              value={user.firstName}
              onChange={handleChange}
              className="form-control"
              required
              style={theme.formInput}
            />
            <br />
            <Label htmlFor="lastName" style={theme.formBodyText}>
              Last Name
            </Label>
            <Input
              type="text"
              id="lastName"
              name="lastName"
              value={user.lastName}
              onChange={handleChange}
              className="form-control"
              required
              style={theme.formInput}
            />
            <br />
            <Label htmlFor="organization" style={theme.formBodyText}>
              Organization/School
            </Label>
            <Input
              type="text"
              id="organization"
              name="organization"
              value={user.organization}
              onChange={handleChange}
              className="form-control"
              required
              style={theme.formInput}
            />
            <br />
            <Button
              type="button"
              color="secondary"
              onClick={() => setActiveTab(null)}
              className="mr-2"
              style={{ ...theme.formSubmit, marginRight: '10px' }}
            >
              Back
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={isLoading}
              style={theme.formSubmit}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm mr-1"></span>
              ) : null}
              Sign In
            </Button>
          </form>
        ) : (
          <form onSubmit={handleIndividualSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
            <h2 id="org-login-heading" style={theme.heading}>
              Individual Test Taker Sign In
            </h2>
            <br />
            <Label htmlFor="orgEmail" style={theme.formBodyText}>
              Email
            </Label>
            <Input
              type="email"
              id="orgEmail"
              name="email"
              value={individualUser.email}
              onChange={handleIndividualChange}
              className="form-control"
              required
              style={theme.formInput}
            />
            <br />
            <Label htmlFor="password" style={theme.formBodyText}>
              Password
            </Label>
            <Input
              type="password"
              id="password"
              name="password"
              value={individualUser.password}
              onChange={handleIndividualChange}
              className="form-control"
              required
              style={theme.formInput}
            />
            <br />
            <div className="mt-3">
              <Button
                type="button"
                color="secondary"
                onClick={() => setActiveTab(null)}
                className="mr-2"
                style={{ ...theme.formSubmit, marginRight: '10px' }}
              >
                Back
              </Button>
              <Button
                type="submit"
                color="primary"
                disabled={isLoading}
                style={theme.formSubmit}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                ) : null}
                Sign In
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default PsychometricTestTakerPortal;